import React from 'react';
import { Bell, Menu } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Select } from '../ui/Select';
import { Role } from '../../types';
interface HeaderProps {
  toggleSidebar: () => void;
  title: string;
}
export function Header({
  toggleSidebar,
  title
}: HeaderProps) {
  const {
    currentUser,
    switchRole
  } = useAuth();
  const roleOptions = [{
    value: 'AdminMaker',
    label: 'Admin Maker'
  }, {
    value: 'AdminChecker',
    label: 'Admin Checker'
  }, {
    value: 'BranchMaker',
    label: 'Branch Maker'
  }, {
    value: 'BranchChecker',
    label: 'Branch Checker'
  }];
  return <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 lg:px-8 fixed top-0 right-0 left-0 lg:left-64 z-30" data-id="element-24">
      <div className="flex items-center" data-id="element-25">
        <button onClick={toggleSidebar} className="lg:hidden mr-3 text-gray-600 hover:text-gray-900" data-id="element-26">
          <Menu className="w-6 h-6" data-id="element-27" />
        </button>
        <img src="https://cdn.magicpatterns.com/uploads/tWYmSpJz5EKRVmEj9X8aaH/CDNS.jpg" alt="CDNS" className="w-8 h-8 object-contain lg:hidden mr-3" data-id="element-28" />
        <h1 className="text-xl font-semibold text-gray-800" data-id="element-29">{title}</h1>
      </div>

      <div className="flex items-center space-x-4" data-id="element-30">
        {/* Role Switcher for Demo */}
        <div className="hidden md:flex items-center space-x-2 bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-200" data-id="element-31">
          <span className="text-xs font-medium text-gray-500 whitespace-nowrap" data-id="element-32">
            Demo Role:
          </span>
          <div className="w-40" data-id="element-33">
            <Select options={roleOptions} value={currentUser?.role || 'AdminMaker'} onChange={e => switchRole(e.target.value as Role)} className="!h-8 !text-xs !rounded-md !border-gray-200 !bg-white" data-id="element-34" />
          </div>
        </div>

        {/* Notifications */}
        <button className="relative p-2 text-gray-500 hover:text-[#1B6B3A] transition-colors" data-id="element-35">
          <Bell className="w-6 h-6" data-id="element-36" />
          <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 bg-[#D4A017] rounded-full border-2 border-white" data-id="element-37"></span>
        </button>

        {/* Branch Display */}
        {currentUser?.branchId && <div className="hidden md:block px-3 py-1 bg-green-50 text-[#1B6B3A] rounded-full text-sm font-medium border border-green-100" data-id="element-38">
            Branch: {currentUser.branchId.toUpperCase()}
          </div>}
      </div>
    </header>;
}